import { CategoryNavMenus } from '../models/category-nav-menus.model';
import { CategoryFilterState } from '../models/category-page.models';
import { filterGroupArrayNames, orderTypes } from '../modules/filters/models/product-filter.models';

import { Category } from '@core/domain/models/category.models';
import { SeoInfo } from '@core/domain/models/seo.models';
import { ProductsArrayPublicModels } from '@features/products/productsArray';
import { InitialSeoInfo } from '@features/seo/infraestructure/state/seo.state';
import { InitialCategory } from '@pages/category/state/category-initial.state';
import { DisplayFilters } from '@shared/ab-testing/models/AB-testing.models';
import { MenuCategory } from '@shared/header/models/category.model';
import { GridTypes } from '@shared/models/grid-type.model';

export interface CategoryState {
    catalogStyles: Record<string, string>;
    category: Category;
    defaultOrders: Partial<Record<orderTypes, number[]>>;
    displayFilter: DisplayFilters; // ECOMDUTI-13739 TEST A/B - Desarrollo Personalización Contenido - Maqueta de filtros
    elementDefaultImageTypes: Map<number, string>;
    filters: CategoryFilterState;
    filterTypeUsedAsSubcategories: filterGroupArrayNames;
    gridElements: any[]; // Grid elements armados.
    isLoaded: boolean;
    landing: MenuCategory;
    lastCategoryState?: CategoryState;
    navMenuCategories?: CategoryNavMenus;
    products: ProductsArrayPublicModels.PublicProductsArray[];
    productsId: number[]; // Vista normal de parrilas
    seoCategoryName: string;
    seoInfo: SeoInfo;
    gridType: GridTypes;
    isSortedPage: boolean;
    lastProductIndexToSort: number;
    isError: boolean;
}

export const InitialFiltersState: CategoryFilterState = {
    filters: null, // Objecto de filtros para armar modulo
    isApplied: false,
    order: {
        orderType: orderTypes.RECOMMENDED,
        isApplied: false,
    },
};

export const InitialCategoryState: CategoryState = {
    catalogStyles: null,
    category: InitialCategory,
    defaultOrders: {},
    displayFilter: 'slider',
    elementDefaultImageTypes: new Map(),
    filters: InitialFiltersState,
    filterTypeUsedAsSubcategories: null,
    gridElements: [],
    isLoaded: null,
    navMenuCategories: undefined,
    products: [],
    productsId: [],
    seoCategoryName: null,
    seoInfo: InitialSeoInfo,
    landing: null,
    gridType: null,
    isSortedPage: false,
    lastProductIndexToSort: null,
    isError: null,
};
